<template>
  <div class="feedback">
    <mPageTitle
      :title="$t('Sugestii și Reclamații')"
      :subtitle="$t('feedback_page_subtitle')"
      :description="$t('feedback_page_description')"
      :image="require('@/assets/images/webp/contact.webp')"
    />

    <aSection
      :background="'#edf8fd'"
      :title="'feedback_how_title'"
      :subtitle="'feedback_how_subtitle'"
    >
      <div class="container feedback__steps">
        <div
          v-for="(step, i) in steps"
          :key="`step-${i}`"
          class="feedback__step-card"
        >
          <div class="feedback__step-number">{{ i + 1 }}</div>
          <h3 class="feedback__step-title">{{ $t(step.title) }}</h3>
          <p class="feedback__step-desc">{{ $t(step.desc) }}</p>
        </div>
      </div>
    </aSection>

    <mFeedbackForm />
  </div>
</template>

<script>
import mPageTitle from "../components/molecules/m-page-title.vue";
import aSection from "../components/atoms/a-section.vue";
import mFeedbackForm from "../components/molecules/m-feedback-form.vue";

const BASE_URL = "https://jeffbrasov.ro";

export default {
  metaInfo() {
    const lang = this.$i18n.locale;
    const pageUrl = `${BASE_URL}/${lang}/sugestii-reclamatii`;
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: this.$t("Acasă"),
          item: `${BASE_URL}/${lang}/`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: this.$t("Sugestii și Reclamații"),
          item: pageUrl,
        },
      ],
    };
    return {
      title: this.$t("seo_title_feedback"),
      meta: [
        { name: "description", content: this.$t("meta_desc_feedback") },
        {
          property: "og:title",
          content: `${this.$t("seo_title_feedback")} | Mr Jeff Brașov`,
        },
        { property: "og:description", content: this.$t("meta_desc_feedback") },
        { property: "og:url", content: pageUrl },
        {
          name: "twitter:title",
          content: `${this.$t("seo_title_feedback")} | Mr Jeff Brașov`,
        },
        { name: "twitter:description", content: this.$t("meta_desc_feedback") },
      ],
      link: [
        { rel: "canonical", href: pageUrl },
        {
          rel: "alternate",
          hreflang: "ro",
          href: `${BASE_URL}/ro/sugestii-reclamatii`,
        },
        {
          rel: "alternate",
          hreflang: "en",
          href: `${BASE_URL}/en/sugestii-reclamatii`,
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: `${BASE_URL}/ro/sugestii-reclamatii`,
        },
      ],
      script: [{ type: "application/ld+json", json: breadcrumbSchema }],
    };
  },
  components: {
    mPageTitle,
    aSection,
    mFeedbackForm,
  },
  data() {
    return {
      steps: [
        { title: "feedback_step_1_title", desc: "feedback_step_1_desc" },
        { title: "feedback_step_2_title", desc: "feedback_step_2_desc" },
        { title: "feedback_step_3_title", desc: "feedback_step_3_desc" },
      ],
    };
  },
  mounted() {
    window.scrollTo({ top: 0 });
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers/breakpoints";

.feedback {
  &__steps {
    display: flex;
    gap: var(--spacer-xl);
    justify-content: center;
    padding: var(--spacer-lg) 0;
    @include for-mobile {
      flex-direction: column;
      gap: var(--spacer-base);
      padding: var(--spacer-sm);
      width: calc(100% - 2rem);
    }
  }

  &__step-card {
    flex: 1;
    text-align: center;
    padding: var(--spacer-xl) var(--spacer-lg);
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(31, 54, 90, 0.08);
    transition: 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 6px 20px rgba(31, 54, 90, 0.12);
    }
  }

  &__step-number {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background-color: var(--c-primary-darken);
    color: var(--c-white);
    font-size: 1.25rem;
    font-weight: var(--font-bold);
    margin-bottom: var(--spacer-base);
  }

  &__step-title {
    font-size: 1.25rem;
    font-weight: var(--font-semibold);
    color: var(--c-dark);
    margin: 0 0 var(--spacer-sm);
  }

  &__step-desc {
    font-size: var(--font-sm);
    line-height: 1.6;
    color: var(--c-dark-lighten);
    margin: 0;
  }
}
</style>
